import {createSelector} from '@reduxjs/toolkit'
import { 
    LICENCE_SUB_TYPE_COLLECTION_AGENCY_APPLICATION, 
    LICENCE_SUB_TYPE_DEBT_MANAGEMENT_APPLICATION 
} from '../../app/constants'
import {applicationReviewSelector} from './applicationReviewSelector'

const agencyChangeRequestSelector = createSelector(
    [state => state.primaryAgencyApplication,
        state => state.additionalApplications],
    ({application}, additionalApplications) => {
        let branches = []

        const branchApps = additionalApplications?.additionalBranchApplications?.filter(app => 
            ((app.licencingSubType === LICENCE_SUB_TYPE_COLLECTION_AGENCY_APPLICATION
            || app.licencingSubType === LICENCE_SUB_TYPE_DEBT_MANAGEMENT_APPLICATION) 
            && app.businessApplicationId !== null) )

        branchApps?.forEach(app => {
            if(app.businessLicenceData?.additionalBranches)
                branches = branches.concat(app.businessLicenceData.additionalBranches) 
        })


        return {
            primaryAgencyApplication : application,
            branches
        }
    }
)

export const agencyChangeRequestSelect = state => ({
    agencyChangeRequest : agencyChangeRequestSelector(state),
    applicationReview : applicationReviewSelector(state)
})